import { ENTITY_TYPES } from 'local/common/dist'

export interface PaymentMethod {
  accountNumber: string
  accountType: PaymentMethodAccountTypes
  cardToken: string
  creditCardType: string
  expirationDate: string
  id: string
  isPrimary: boolean
  nameOnCard: string
}

export interface ApiError {
  Message: string
}

export enum PaymentMethodAccountTypes {
  ACH = 'ACH',
  CreditCard = 'CreditCard',
}

export interface CardCapturedInput {
  entityType: ENTITY_TYPES
  entityId: number
  last4DigitsOfCardOnFile: string
}
